<template>
  <v-card class="create-sor">
    <v-card-title>
      {{ $t('dataset.create_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">Title
          </v-col>
          <v-col cols="9">
            <v-text-field outlined
                          dense
                          v-model="title"
                          :rules="requiredRules"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-6">
          <v-col cols="3"
                 class="input-label">Types
          </v-col>
          <v-col cols="9">
            <v-checkbox v-for="t in types"
                        hide-details
                        dense
                        v-model="typeIds"
                        :label="t.name"
                        :value="t.id"></v-checkbox>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">Value Type
          </v-col>
          <v-col cols="9">
            <v-select outlined
                      hide-details
                      dense
                      :items="valueTypeOptions"
                      v-model="valueType"></v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && save()"
             depressed
             large>
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import {RBU_DATASET_VALUE_TYPE} from "@/constants";

export default {
  name: 'CreateDatasetDialog',
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required')
    ]);

    const title = ref('');
    const typeIds = ref([]);
    const types = ref([]);
    const getTypes = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/dataset_type/',
        params: {
          page_size: -1,
        },
      });

      if (response.body.success) {
        types.value = response.body.types;
      }
    }

    const valueType = ref(RBU_DATASET_VALUE_TYPE.PRICE);
    const valueTypeOptions = ref([
      {text: 'Price', value: RBU_DATASET_VALUE_TYPE.PRICE},
      {text: 'Index', value: RBU_DATASET_VALUE_TYPE.INDEX},
    ]);

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/dataset/create/',
        params: {
          value_type: valueType.value,
          title: title.value,
          type_ids: typeIds.value,
        }
      });

      if (response.body.success) {
        emit('submit', response.body.dataset.id)
      }
    }

    onMounted(() => {
      getTypes();
    })

    return {
      requiredRules,
      title,
      typeIds,
      types,

      valueType,
      valueTypeOptions,

      save,
    }
  },
}
</script>
